import { cloneElement, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { type ButtonProps, classes, type IconElement } from './utils';

export interface IconButtonProps extends ButtonProps {
  filled?: boolean;
  icon: IconElement;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ filled, className, icon, ...props }, ref) => {
    const { className: iconClassName, ...iconProps } = icon.props;
    return (
      <button
        ref={ref}
        className={twMerge(
          classes.buttonBase,
          filled ? classes.buttonFilled : classes.button,
          className
        )}
        {...props}>
        {cloneElement(icon, {
          ...iconProps,
          className: twMerge(
            classes.iconBase,
            filled ? classes.iconFilled : classes.icon,
            iconClassName
          ),
        })}
      </button>
    );
  }
);

export default IconButton;
